export const groupScreeningMatches = (screeningMatches: { name: string; id: number; doc: any }[]) => {
	const sanctioned = [];
	const pep = [];
	const adverseMedia = [];

	for (const hit of screeningMatches) {
		if (!Array.isArray(hit.doc.types)) continue;

		if (hit.doc.types.some((type: string) => type.startsWith('sanction'))) {
			sanctioned.push(hit);
		}
		if (hit.doc.types.some((type: string) => type.startsWith('adverse-media'))) {
			adverseMedia.push(hit);
		}
		if (hit.doc.types.some((type: string) => type.startsWith('pep'))) {
			pep.push(hit);
		}
	}

	return {
		sanctioned,
		pep,
		adverseMedia,
		hasMatches: Boolean(sanctioned.length || pep.length || adverseMedia.length),
	};
};
